<template>
  <div class="flex-1 pl-3" :class="{ 'px-4 py-3 border': !subtle }">
    <div class="flex">
      <NoteDescription class="flex-1 mt-1" :description="note.description" />
      <div class="w-2 ml-4">
        <div class="w-2 h-2 rounded-full mr-2 mt-2 bg-orange-400" v-if="note.deal"></div>
      </div>
      <BaseDropdown class="text-base" icon="more-vertical" button-class="btn-icon">
        <ModalButton class="dropdown-item w-40" label="Wijzigen">
          <NoteForm
            method="patch"
            :action="`/json/contacts/${$store.state.contact.id}/notes/${note.id}`"
            :note="note"
            @success="success"
          />
        </ModalButton>
        <DeleteConfirmButton
          class="dropdown-item"
          message="Wil je deze notitie verwijderen?"
          @confirm="deleteNote"
        >Verwijderen</DeleteConfirmButton>
      </BaseDropdown>
    </div>
  </div>
</template>

<script>
import { destroy } from "@/api";
import NoteForm from "@/components/NoteForm";
import NoteDescription from "@/components/NoteDescription";
import DeleteConfirmButton from "@/components/DeleteConfirmButton";

export default {
  props: {
    activity: Object,
    subtle: Boolean
  },

  components: {
    NoteForm,
    NoteDescription,
    DeleteConfirmButton
  },

  computed: {
    note() {
      return (
        this.activity.subject || { description: "Deze notitie is verwijderd" }
      );
    }
  },

  methods: {
    success(data) {
      this.$store.commit("SET_CONTACT", data);
    },

    deleteNote() {
      let contactId = this.$store.state.contact.id;
      destroy(`/contacts/${contactId}/notes/${this.note.id}`).then(
        response => {
          this.$store.commit("SET_CONTACT", response.data);
          this.$store.commit("FLASH_ADD", { message: "Notitie is verwijderd" });
        }
      );
    }
  }
};
</script>
